// Copyright (c) 2017 Deere & Company

import AllClaims from './components';
import Facets from './state/facets';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import reports from '../../routes/claims/reports';

const getStateToBindToContainerProps = state => ({
    ...state.claims.allClaims,
    claimSearchCount: state.claims.claimSearch.searchResults.length,
    dealerInvoiceCount: state.claims.dealerInvoices.dealerInvoices.length,
    exportToExcel: state.exportToExcel,
    facets: new Facets({
        ...state.claims.allClaims.facets,
        claimStatusFacet: {
            ...state.claims.allClaims.facets.claimStatusFacet,
            allowedStatus: state.user.details.settings.claims.status.selectedStatuses
        },
        dealerAccountsFacet: {
            ...state.claims.allClaims.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        }
    }),
    reportsRoutes: reports(state),
    searchByDropDown: state.claims.searchDropDown,
    searchQueryString: state.claims.searchQueryString,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(AllClaims);



// WEBPACK FOOTER //
// ./src/claim/all-claims/state-connector.js